// extracted by mini-css-extract-plugin
export default {"createdCompaniesTable":"createdCompaniesTable__raGesT0y","headerLabel":"headerLabel__WwAip9bj","tooltip":"tooltip__z9lUK12g"};